export const RouteConstants = {
    LOGIN: "/login",
    TEST_DASHBOARD: "/test-dashboard",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
    EDIT_PERSONAL_INFO: "/profile/edit",
    EDIT_SECURITY_INFO: "/profile/security/edit",
    EDIT_PASSWORD_INFO: "/profile/password/edit",
    PURCHASE_HISTORY: "/purchase-history",
    AUTH_CALLBACK: "/callback",
    LOGOUT: "/logout",
    AUTH_ERROR: "/auth-error",
    REDIRECTION_ERROR: "/redirection-error",
    ADMIN: "/admin",
    ADMIN_SKU_MANAGEMENT: "/admin/manage-sku",
    ADMIN_COUPON_MANAGEMENT: "/admin/manage-coupon",
    FORGOT_PASSWORD: "/forgot-password",
    FORGOT_USERNAME: "/forgot-username",
    FORGOT_USERNAME_SENT: "/forgot-username/sent",
    FORGOT_PASSWORD_SENT: "/forgot-password/sent",
    INCOMPLETE_REGISTRATION: "/incomplete-registration",
    COMPLETE_REGISTRATION_REQUEST_EMAIL_SENT: "/complete-registration-request-email-sent",
    PASSWORD_RESET_AUTH: "/password-reset-auth",
    PASSWORD_RESET: "/password-reset",
    PASSWORD_RESET_ERROR: "/password-reset/error",
    REGISTER: "/register",
    OTC_CALLBACK: "/otcCallback",
    UPDATE_EMAIL: "/update",
    UPDATE_EMAIL_SECURITY: "/update/security",
    UPDATE_EMAIL_NEW: "/update/new",
    UPDATE_EMAIL_COMPLETE: "/update/complete",

    //temporary routes
    OTC_LOAD: "/otc",
};